var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShipHealth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Ship_Health_"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ship_Health_",
    "data-name": "Ship Health ",
    clipPath: "url(#clip-Ship_Health_)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_768",
    "data-name": "Group 768",
    transform: "translate(-252 -645)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_558",
    "data-name": "Ellipse 558",
    cx: 24,
    cy: 24,
    r: 24,
    transform: "translate(252 645)",
    className: "icon-background"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_164",
    "data-name": "Group 164",
    transform: "translate(292.021 680.527) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M0,11.5l.261,2.217.627,2.164,1.2,1.956L3.5,19.557l1.826,1.435,2.034,1.1,2.374.627,2.4.313s11.78-1.37,13.575-1.734a15.209,15.209,0,0,0,3.612-.9c1.629-.743,2.268-5.112,2.374-6.05a44.931,44.931,0,0,0-.5-9.284A5.414,5.414,0,0,0,28.238,1.9L11.965,0,9.592.313,7.453.887,5.392,1.956l-1.8,1.378-1.539,1.8L1.011,7.168.333,9.2Zm23.485,6.194,1.486-1.773.261-.6H25.6l.065.143.417.026.808-.7s.157-.835.157-.886.053-3.885.053-3.885-.105-1.513-.183-1.773l-.808-.653h-.442l-.053.1h-.391l-.234-.548L23.606,5.294l.835-.261,1.773-.861,1.278.053.7.47.209.444v.573A8.876,8.876,0,0,0,28.2,7.068c-.053.731-.183,2.712-.183,2.712v3.39l.079,1.643s.125,1.46.157,1.617.222,1.421.222,1.421l-.105.34-.835.469H26.253Z",
    transform: "translate(31.742 23.027) rotate(180)",
    className: "icon-foreground"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShipHealth);
export default __webpack_public_path__ + "static/media/shipHealth.d0b1c4f09386652fd7b27bc8579f9d90.svg";
export { ForwardRef as ReactComponent };